// (C) 2022 GoodData Corporation
import { FormatterFactory } from "./factory.js";
import { DefaultFormatterMatchers } from "./regex.js";
/**
 * Default implementation of the formatter facade; logic & parts of implementation ported from the funky
 * JavaScript implementation in https://github.com/gooddata/gdc-numberjs
 *
 * For the record, the original implementation was based on this ancient piece:
 * https://github.com/flavorjones/flexible-js-formatting/blob/master/numbers/number-functions.js
 * @beta
 */
export class DefaultFormatterFacade {
    constructor() {
        this.matchers = new DefaultFormatterMatchers();
        this.factory = new FormatterFactory(this.matchers);
    }
    /**
     * Factory that compiles raw format string into a Formatter.
     *
     * This is the main method that can accept any type of format string. It will analyze the format string, identify
     * conditional formatting, arithmetic operations, and actual format strings for each and compile an appropriate
     * Formatter.
     *
     * Note: The formatters created by this method are automatically decorated with the SpecialValueGuard.
     *
     * @param format - format string to compile
     * @returns an instance of formatter compiled for the input format string; caller should make no assumptions
     *  about getting new or same instance for the same format string
     * @throws Error if the format contains errors and cannot be compiled
     */
    compileFormatter(format) {
        return this.factory.compileFormatter(format);
    }
}
//# sourceMappingURL=facade.js.map